import { useTranslation } from 'react-i18next';

import FormPanel from 'components/common/FormPanel';
import FormikTextField from 'components/InputsField/formikInputs/FormikTextField';
import {
  numberInput,
  floatNormalize50,
  floatNormalize9999,
} from 'components/InputsField/inputFormats';

import styles from './styles.module.scss';

const SizesStep = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.step}>
      <FormPanel title={t('transportFields.steps.sizes_panel')}>
        <FormikTextField
          name="carrying_capacity"
          label={t('transportFields.vehicle_size_section.weight')}
          maxLength="6"
          placeholder={t('forms.startEnter')}
          format={numberInput}
          normalize={floatNormalize9999}
          errorMode="static"
        />
        <FormikTextField
          name="volume"
          label={t('transportFields.vehicle_size_section.capacity')}
          maxLength="6"
          placeholder={t('forms.startEnter')}
          format={numberInput}
          normalize={floatNormalize9999}
          errorMode="static"
        />
        <FormikTextField
          name="length"
          label={t('transportFields.vehicle_size_section.length')}
          maxLength="4"
          placeholder={t('forms.startEnter')}
          format={numberInput}
          normalize={floatNormalize50}
          errorMode="static"
        />
        <FormikTextField
          name="width"
          label={t('transportFields.vehicle_size_section.width')}
          maxLength="4"
          placeholder={t('forms.startEnter')}
          format={numberInput}
          normalize={floatNormalize50}
          errorMode="static"
        />
        <FormikTextField
          name="height"
          label={t('transportFields.vehicle_size_section.height')}
          maxLength="4"
          placeholder={t('forms.startEnter')}
          format={numberInput}
          normalize={floatNormalize50}
          errorMode="static"
        />
      </FormPanel>
    </div>
  );
};

export default SizesStep;
